<template>
  <div class="circus_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'马戏团巡礼活动-使魔计划'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-smjh' v-show='preloadingShow'></div>
    </transition>
    <div class="content">
      <div class="title">
        <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="../../../../assets/images/active/servitor/circus/title.png"/>
        </transition>
      </div>
      <div class="sub_title">
        <transition enter-active-class="animated zoomInDown" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="../../../../assets/images/active/servitor/circus/sub_title.png"/>
        </transition>
      </div>
      <div class="detail_btn circus_sprite circus_detail_btn" @click="openPopup('detailShow')"></div>
      <div class="award_list"></div>
      <div class="operation_box">
        <div v-if="activeInfo.gear_refund" class="btn circus_sprite circus_return_gray_btn"></div>
        <div v-else class="btn circus_sprite circus_return_btn" @click="onReturnCash()">
          <p>打卡进度：{{activeInfo.cur || 0}}/15</p>
        </div>
        
        <div v-if="showPayBtn" class="btn circus_sprite circus_pay_btn" @click="onJoinActive()">
          <p v-if="!userInfo.role_id">请先登录</p>
          <p v-else>{{endDate}} 截止购买</p>
        </div>
        <div v-else class="btn circus_sprite circus_pay_gray_btn"></div>
      </div>
    </div>
    <Footer :gameName="gameName" />
    <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" />
    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :loginTypes="loginTypes"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <!-- 弹窗类 -->
    <!-- 活动详情 -->
    <div class="detail_wrap popup_wrap" v-show="detailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="detailShow">
          <div class="detail">
            <img src="../../../../assets/images/active/servitor/circus/popup/detail_popup.png" alt="详情">
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="detailShow" @click="closePopup('detailShow')"></div>
    </div>
    <!-- 返现成功 -->
    <div class="cash_back_wrap popup_wrap" v-show="cashBackShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="cash_back_box" v-show="cashBackShow">
          <div class="confirm_btn" @click="closePopup('cashBackShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="cashBackShow" @click="closePopup('cashBackShow')"></div>
    </div>
    <!-- 协议内容 -->
    <div class="protocol_wrap popup_wrap" v-show="protocolShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="protocol_box" v-show="protocolShow">
          <p class="server_name">{{ userInfo.server_name || '' }}</p>
          <p class="user_name">{{ userInfo.role_name || '' }}</p>
          <div class="cancel_btn" @click="closePopup('protocolShow')"></div>
          <div class="confirm_btn" @click="openPopup('payWayShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="protocolShow" @click="closePopup('protocolShow')"></div>
    </div>
    <!-- 支付选择 -->
    <div class="pay_way_wrap popup_wrap" v-show="payWayShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="pay_way_box" v-show="payWayShow">
          <div class="pay_channel">
            <div class="wechat" @click="selectPayWay(1)">
              <div class="icon circus_sprite circus_wechat_pay_icon"></div>
              <div class="name">微信支付</div>
              <div :class="'checkbox ' + (payWay === 1 ? 'active' : '')"></div>
            </div>
            <div class="alipay" v-if="!isWechatBrowser" @click="selectPayWay(2)">
              <div class="icon circus_sprite circus_ali_pay_icon"></div>
              <div class="name">支付宝支付</div>
              <div :class="'checkbox ' + (payWay === 2 ? 'active' : '')"></div>
            </div>
          </div>
          <div class="confirm_btn" @click="goToPay()"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="payWayShow" @click="closeSelectPayWay()"></div>
    </div>
    <!-- 支付提示-弹窗 -->
    <div class="payment_tips_page popup_wrap" v-show="paymentTipsShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="payment_tips_box" v-show="paymentTipsShow">
          <h2>提示</h2>
          <p>请确认是否完成支付</p>
          <div>
            <a @click="orderQuery(1)" href="javascript:;">已完成支付</a>
            <a @click="orderQuery(2)" href="javascript:;">未完成支付</a>
          </div>
        </div>
      </transition>
    </div>
    <!-- 支付成功 -->
    <div class="pay_success_wrap popup_wrap" v-show="paySuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="pay_success_box" v-show="paySuccessShow">
          <div class="confirm_btn" @click="closePopup('paySuccessShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="paySuccessShow" @click="closePopup('paySuccessShow')"></div>
    </div>
    <!-- 支付失败 -->
    <div class="pay_fail_wrap popup_wrap" v-show="payFailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="pay_fail_box" v-show="payFailShow">
          <p>{{ payFailMessage }}</p>
          <div class="confirm_btn" @click="closePopup('payFailShow')"></div>
        </div>
      </transition>
      <div class="close-bg" v-if="payFailShow" @click="closePopup('payFailShow')"></div>
    </div>
    <!-- 支付宝调用标签 -->
    <div id="aliPayBtn"></div>
    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '@/components/Header';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import { onGetInitDataAPI, onAutoLoginAPI, onPayAPI, onQueryOrderAPI, wechatInfoAPI, onRefundAPI, getCardInfoAPI } from '../api';
import { analysisParams, getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';

const payList = [
  { name: '微信支付_wechatApp', payType: 'wechat', payMethod: 'mp' },
  { name: '微信支付_h5', payType: 'wechat', payMethod: 'wap' },
  { name: '支付宝支付', payType: 'alipay', payMethod: 'wap' },
];

export default {
  name: 'circus',
  components: {
    Header,
    Footer,
    Login,
    Os
  },
  data () {
    return {
      headerConfig,
      gameName: "servitor",
      loginTypes: ["sms", "password"],
      downloadUrl: 'http://smjh.qingcigame.com/leading/',
      preloadingShow: true,
      titleShow: false,

      detailShow: false, // 活动详情 弹窗
      cashBackShow: false, // 返现成功 弹窗
      protocolShow: false, // 协议 弹窗
      payWayShow: false, // 支付选择 弹窗
      paySuccessShow: false, // 支付成功 弹窗
      payFailShow: false, // 支付失败 弹窗
      preventShow: false,
      paymentTipsShow: false,
      
      isWechatBrowser: false, // 是否为微信浏览器

      showPayBtn: true, //显示付款按钮
      isExpired: false, // 是否超过截止时间
      endDate: '',
      payConfig: null, // 支付配置
      payWay: 0, // 0: 未选择  1： 微信支付  2：支付宝支付
      open_id: null,
      payFailMessage: '当前有一笔订单正在支付中，请稍后重试...', // 支付失败 错误信息
    };
  },
  created () {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下
      this.payConfig = {
        1: { ...payList[0] }
      };
    } else {
      this.payConfig = {
        1: { ...payList[1] },
        2: { ...payList[2] }
      };
    }
    // 埋点
    const bl = buriedLogger('servitor', '马戏团巡礼活动');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/servitor/circus/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    // 解析query 是否免密登录
    const params = analysisParams(window.location.href);
    if (params.role_id && params.token) {
      // 免密登陆
      onAutoLoginAPI({...params})
        .then((response) => {
          if (response.code !== 200) {
            // 记录错误
            bl.error({name:'免登录API错误', message:`params: ${JSON.stringify(params)}`});
          }
          reload();
        }).catch((err) => {
          // 记录错误
          bl.error({name:'免登录错误', message:`params: ${JSON.stringify(params)}`});
          reload();
        });
    } else {
      if (this.isWechatBrowser) {
        // 微信app内，需要获取openid才能做微信支付
        wechatInfoAPI().then((response) => {
          if (Number(response.code) == 200) {
            this.open_id = response.data.open_id;
            if (response.data.open_id == null) {
              window.location.href = '//api.qingcigame.com/wechat/get/open/?back=' + encodeURIComponent(window.location.href)
              return
            }
            this.getCardInfo();
          } else {
            bl.error({name:'微信授权信息错误', message:`详情: ${response.message}`});
            this.onToast(response.message);
            this.preloadingShow = false;
          }
        });
      } else {
        // 获取打卡信息
        this.getCardInfo();
      }
    }
    this.isSetShare();
  },
  mounted () {
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearActiveInfo();
        }
      }
    },
    activeInfo: {
      handler(newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          const { countdown_time = '', is_echarge } = newValue;
          this.showPayBtn = is_echarge === false;
          if (countdown_time) {
            const date = new Date(countdown_time);
            const curDate = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.isExpired = curDate.getTime() > date.getTime();
            this.endDate = `${year}年${month}月${day > 9 ? day : ('0' + day)}日`
          } else {
            this.isExpired = true;
            this.endDate = '';
          }
        }
      }
    },
  },
  methods: {
    // 清除data里面相关数据
    clearActiveInfo() {
      this.showPayBtn = true;
      this.endDate = '';
      this.isExpired = false;
    },
    // 选择角色后
    selectCallback() {
      this.getCardInfo();
    },
    osCancell() {},
    // 业务代码
    onReturnCash() {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      if (!this.activeInfo.is_echarge) {
        this.onToast('当前账户未参与活动，请先付款');
        return false;
      }
      if (!this.activeInfo.is_refund) {
        this.onToast('打卡进度未完成，无法退款！');
        return false;
      }
      this.preventShow = true;
      onRefundAPI().then(() => {
        this.preventShow = false;
        this.openPopup('cashBackShow');
        onGetInitDataAPI().then(response => {
          this.onInitDataCallback(response);
        });
      }).catch(() => {
        this.preventShow = false;
      });
      this.logger.sum('返现按钮');
    },
    onJoinActive() {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      if (this.isExpired) {
        this.onToast('已超过截止日期');
        this.logger.sum('付款_超过截止日期');
        return false;
      }
      this.openPopup('protocolShow');
      this.logger.sum('付款按钮');
    },
    selectPayWay(id) {
      if (this.payWay === id) {
        return false;
      }
      this.payWay = id;
    },
    closeSelectPayWay() {
      this.payWay = 0;
      this.closePopup('payWayShow');
    },
    getCardInfo () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.preloadingShow = false;
        this.titleShow = true;
        if (response.code === 200) {
          getCardInfoAPI().then(() => {
            // 获取卡信息之后，还要重新获取一遍用户信息
            onGetInitDataAPI().then((res) => {
              this.onInitDataCallback(res);
            })
          });
        } else {
          this.setInitUserInfo();
          this.setInitActiveInfo();
          // this.clearActiveInfo();
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    goToPay() {
      if (this.payWay === 0) {
        this.onToast('请选择支付方式');
        return false;
      }
      this.preventShow = true;
      const curPay = this.payConfig[this.payWay];
      onPayAPI({ pay_type: curPay.payType, pay_method: curPay.payMethod, open_id: this.open_id })
      .then((response) => {
        if (Number(response.code) == 200) {
          this.order = response.data.order;
          this.paymentTipsShow = true;
          // 移动端支付
          if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // 微信发送支付
            if (curPay.payType == 'wechat') {
              if (curPay.payMethod == 'mp') {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    setTimeout(() => { this.preventShow = false }, 1000);
                  },
                  fail: function (res) {
                    setTimeout(() => { this.preventShow = false }, 1000);
                  }
                })
                setTimeout(() => { this.preventShow = false }, 2000);
              } else {
                if (response.data.data !== '') {
                  window.location.href = response.data.data
                  setTimeout(() => { this.preventShow = false }, 1000)
                }
              }
            } else if (response.data.data !== '') {
              document.getElementById('aliPayBtn').innerHTML = response.data.data
              document.forms['alipaysubmit'].submit()
              setTimeout(() => { this.preventShow = false }, 1000)
            }
          }
          
          this.logger.sum('点击立即支付按钮');
          this.payShow = false;
          return false;
        }
        this.onToast(response.message);
        setTimeout(() => { this.preventShow = false }, 500);
      }).catch(() => {
        this.preventShow = false;
      });
    },
    orderQuery (type) {
      this.paymentTipsShow = false;
      // 订单轮询
      type == 1 ? this.wait = 15 : this.wait = 2;
      this.orderLoop(type);
      this.logger.sum(`订单轮询_${type === 1 ? '已完成订单' : '未完成订单'}`);
    },
    // 订单轮询
    orderLoop (i) {
      if (this.wait > 0) {
        this.onPayment(i)
        this.wait--;
        this.preventShow = true;
        Indicator.open()
        setTimeout(() => { this.orderLoop(i); }, 1500);
      } else {
        this.preventShow = false;
      }
    },
    onPayment (i) {
      onQueryOrderAPI({trade_no: this.order})
      .then((response) => {
        if (Number(response.code) === 200) {
          // 支付成功
          this.wait = 0;
          if (i == 1) this.onToast(response.message);
          this.payWayShow = false; // 关闭支付弹窗
          this.preventShow = false;
          this.paySuccessShow = true;
          Indicator.close();
          onGetInitDataAPI().then(res => {
            this.onInitDataCallback(res);
          });
          return;
        } else {
          if (this.wait == 0) {
            if (i == 1) {
              this.payFailMessage = response.message;
              this.openPopup('payFailShow');
            };
            Indicator.close();
            onGetInitDataAPI().then(res => {
              this.onInitDataCallback(res);
            });
          }
        }
      });
    },
    // TAG: 其他简易封装的方法
    openPopup (name) {
      this[name] = true;
    },
    closePopup (name) {
      this[name] = false;
    },
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts"
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/servitor/circus/enter${getRandomString()}`,
        title: '',
        imgUrl: '',
        desc: ''
      })
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/servitor/circus/index/index.vue